export default "__VITE_ASSET__4a53aa89__"